/** i18n piatto pattern Sequo. IT/EN dal giorno 1, default EN (portali internazionali). */

export type Lang = 'en' | 'it';

const STORAGE_KEY = 'tilt:lang';

const dict = {
  'tagline': { en: 'Roll. Hold. Push your luck.', it: 'Lancia. Tieni. Sfida la sorte.' },
  'menu.start': { en: 'START THE RUN', it: 'INIZIA LA RUN' },
  'menu.hint': {
    en: '12 rounds, 3 hands each. Beat the target, buy talismans, break the table.',
    it: '12 round, 3 mani ciascuno. Batti l’obiettivo, compra talismani, sbanca il tavolo.',
  },
  'action.roll': { en: 'ROLL', it: 'LANCIA' },
  'action.reroll': { en: 'REROLL ({n})', it: 'RILANCIA ({n})' },
  'action.force': { en: '⚡ PUSH IT', it: '⚡ FORZA IL TIRO' },
  'action.bank': { en: 'BANK IT', it: 'INCASSA' },
  'action.next': { en: 'NEXT HAND', it: 'PROSSIMA MANO' },
  'hint.hold': { en: 'Tap dice to hold them', it: 'Tocca i dadi per tenerli' },
  'hint.rollsLeft': { en: 'rerolls left', it: 'rilanci rimasti' },
  'tilt.hint': {
    en: 'Free rerolls are gone. Forcing one charges the TILT bar…',
    it: 'I rilanci liberi sono finiti. Forzarne uno carica la barra TILT…',
  },
  'tilt.chaos': { en: 'FULL TILT! The table lurches…', it: 'TILT PIENO! Il tavolo sbanda…' },
  'score.chips': { en: 'Chips', it: 'Chips' },
  'score.mult': { en: 'Mult', it: 'Molt.' },
  'score.total': { en: 'Score', it: 'Punti' },
  'hud.round': { en: 'ROUND {n}', it: 'ROUND {n}' },
  'combo.pair': { en: 'Pair', it: 'Coppia' },
  'combo.two-pair': { en: 'Two Pair', it: 'Doppia Coppia' },
  'combo.three-kind': { en: 'Trips', it: 'Tris' },
  'combo.full-house': { en: 'Full House', it: 'Full' },
  'combo.small-straight': { en: 'Mini Run', it: 'Scala Corta' },
  'combo.large-straight': { en: 'Big Run', it: 'Scala Lunga' },
  'combo.four-kind': { en: 'Quad Squad', it: 'Poker' },
  'combo.five-kind': { en: 'QUINTS!', it: 'QUINTETTO!' },
  'combo.six-kind': { en: 'THE SESTETTO', it: 'SESTETTO' },
  'combo.chance': { en: 'Loose Change', it: 'Somma Secca' },
  'rarity.comune': { en: 'common', it: 'comune' },
  'rarity.raro': { en: 'rare', it: 'raro' },
  'rarity.leggendario': { en: 'legendary', it: 'leggendario' },
  'shop.title': { en: 'THE BANK', it: 'IL BANCO' },
  'shop.cleared': { en: 'target cleared', it: 'obiettivo battuto' },
  'shop.slots': { en: 'talismans {a}/{b}', it: 'talismani {a}/{b}' },
  'shop.die': { en: 'special die', it: 'dado speciale' },
  'shop.sold': { en: 'SOLD', it: 'VENDUTO' },
  'shop.reroll': { en: 'New offer (◉ {n})', it: 'Cambia offerta (◉ {n})' },
  'shop.continue': { en: 'TO ROUND {n}', it: 'AL ROUND {n}' },
  'over.title': { en: 'RUN OVER', it: 'RUN OVER' },
  'over.reached': { en: 'The table got you at round {n}.', it: 'Il tavolo ti ha fregato al round {n}.' },
  'over.best': { en: 'best hand', it: 'mano migliore' },
  'over.hands': { en: 'hands played', it: 'mani giocate' },
  'over.talismans': { en: 'talismans', it: 'talismani' },
  'over.again': { en: 'ONE MORE RUN', it: 'ANCORA UNA RUN' },
  'won.title': { en: 'YOU BROKE THE TABLE', it: 'HAI SBANCATO IL TAVOLO' },
  'won.sub': { en: 'Twelve rounds. The bar goes quiet.', it: 'Dodici round. Il bar si è zittito.' },
  'footer.sprint0': {
    en: 'Sprint 1 build — bosses, characters & the daily are coming.',
    it: 'Build Sprint 1 — boss, personaggi e la Daily in arrivo.',
  },
  // ── Guida completa ──
  'guide.open': { en: 'HOW TO PLAY', it: 'COME SI GIOCA' },
  'guide.title': { en: 'HOW TO PLAY', it: 'COME SI GIOCA' },
  'guide.close': { en: 'GOT IT, LET’S ROLL', it: 'HO CAPITO, SI GIOCA' },
  'guide.goal.h': { en: 'The run', it: 'La run' },
  'guide.goal.p': {
    en: 'A run is 12 rounds. Each round gives you at most 3 hands to reach the target score — the round score is the SUM of your hands. Run out of hands below the target and the run is over. Every cleared round pays Pips (◉), the bank’s currency.',
    it: 'Una run dura 12 round. In ogni round hai al massimo 3 mani per raggiungere l’obiettivo — il punteggio del round è la SOMMA delle tue mani. Se le mani finiscono sotto l’obiettivo, la run è finita. Ogni round superato paga in Pips (◉), la valuta del banco.',
  },
  'guide.hand.h': { en: 'The hand', it: 'La mano' },
  'guide.hand.p': {
    en: 'You roll 6 dice. Tap the ones you want to KEEP, reroll the rest: you get 2 free rerolls. When you bank, the game automatically picks the best combo on the table — you can’t pick wrong.',
    it: 'Lanci 6 dadi. Tocca quelli che vuoi TENERE e rilancia gli altri: hai 2 rilanci liberi. Quando incassi, il gioco sceglie da solo la combinazione migliore sul tavolo — impossibile sbagliare.',
  },
  'guide.score.h': { en: 'Chips × Mult', it: 'Chips × Molt.' },
  'guide.score.p': {
    en: 'Score = Chips × Mult. Chips = the combo’s base value + the pips of the dice it uses. Mult starts at 1: talismans are what push it up — that’s where the numbers explode.',
    it: 'Punteggio = Chips × Molt. I Chips sono la base della combinazione + i pips dei dadi che la compongono. Il Molt. parte da 1: sono i talismani a farlo salire — è lì che i numeri esplodono.',
  },
  'guide.combos.h': { en: 'The combos', it: 'Le combinazioni' },
  'guide.combos.p': {
    en: 'Base values. Loose Change (the sum of all six dice) always counts: you can never score zero.',
    it: 'Valori base. La Somma Secca (somma di tutti e sei i dadi) vale sempre: non puoi mai fare zero.',
  },
  'guide.tilt.h': { en: 'The TILT', it: 'Il TILT' },
  'guide.tilt.p': {
    en: 'Out of free rerolls? You can FORCE extra rolls, as many as you dare: each one charges the TILT gauge by 35. At full gauge the table lurches: the NEXT roll is rigged against you (every die rolls twice and keeps the worse face), then the gauge empties. The Risk family lives up there: Berserk flips the chaos in your favor.',
    it: 'Finiti i rilanci liberi puoi FORZARE il tiro, quante volte osi: ogni forzatura carica la livella TILT di 35. A barra piena il tavolo sbanda: il PROSSIMO lancio è truccato contro di te (ogni dado tira due volte e tiene la faccia peggiore), poi la barra si svuota. La famiglia Rischio vive lassù: Berserk inverte il caos a tuo favore.',
  },
  'guide.shop.h': { en: 'The bank', it: 'Il banco' },
  'guide.shop.p': {
    en: 'After each cleared round the bank offers 2 talismans and a special die. Reward = 4 Pips + 1 per unused hand + interest (1 per 5 Pips saved, max 3). A new offer costs 2. You have 5 talisman slots: choose badly and you live with it.',
    it: 'Dopo ogni round superato il banco offre 2 talismani e un dado speciale. Ricompensa = 4 Pips + 1 per ogni mano risparmiata + interessi (1 ogni 5 Pips in cassa, max 3). Cambiare offerta costa 2. Hai 5 slot talismano: scegli male e te li tieni.',
  },
  'guide.tal.h': { en: 'The talismans', it: 'I talismani' },
  'guide.tal.p': {
    en: 'Passives that break the rules, in 5 families — each pushes a different build. In game, tap a talisman pill to re-read what it does.',
    it: 'Passivi che rompono le regole, in 5 famiglie — ognuna spinge una build diversa. In gioco, tocca la pillola di un talismano per rileggere cosa fa.',
  },
  'guide.dice.h': { en: 'Special dice', it: 'I dadi speciali' },
  'guide.dice.p': {
    en: 'Bought at the bank, each replaces one normal die for the rest of the run.',
    it: 'Si comprano al banco: ognuno sostituisce un dado normale per il resto della run.',
  },
  'guide.base': { en: 'base', it: 'base' },
  'guide.chance-base': { en: 'sum of all dice', it: 'somma di tutti i dadi' },
  'fam.fissazioni': { en: 'Fixations', it: 'Fissazioni' },
  'fam.pirotecnici': { en: 'Pyrotechnics', it: 'Pirotecnici' },
  'fam.spettrali': { en: 'Spectral', it: 'Spettrali' },
  'fam.alchemici': { en: 'Alchemical', it: 'Alchemici' },
  'fam.rischio': { en: 'Risk', it: 'Rischio' },
  // ── Personaggi ──
  'char.title': { en: 'WHO SITS AT THE TABLE?', it: 'CHI SIEDE AL TAVOLO?' },
  'char.bilanciato.name': { en: 'The Balanced', it: 'Il Bilanciato' },
  'char.bilanciato.desc': { en: 'No tricks. Just dice.', it: 'Nessun trucco. Solo dadi.' },
  'char.fabbro.name': { en: 'The Smith', it: 'Il Fabbro' },
  'char.fabbro.desc': {
    en: 'Starts with the Bomb Die; dice cost 2 less at the bank.',
    it: 'Parte col Dado Bomba; i dadi al banco costano 2 in meno.',
  },
  'char.spiritista.name': { en: 'The Spiritist', it: 'Lo Spiritista' },
  'char.spiritista.desc': {
    en: '6 talisman slots, but targets are 15% higher.',
    it: '6 slot talismano, ma obiettivi +15%.',
  },
  'char.berserker.name': { en: 'The Berserker', it: 'Il Berserker' },
  'char.berserker.desc': {
    en: 'Every round starts at TILT 50; Risk talismans cost 2 less.',
    it: 'Ogni round parte con TILT 50; i talismani Rischio costano 2 in meno.',
  },
  // ── Boss ──
  'boss.label': { en: 'BOSS', it: 'BOSS' },
  'boss.no-sei.name': { en: 'Sixes Don’t Exist', it: 'I 6 Non Esistono' },
  'boss.no-sei.desc': { en: 'Sixes are worth 0 pips.', it: 'I 6 valgono 0 pips.' },
  'boss.pool-rilanci.name': { en: 'Rationing', it: 'Contingente' },
  'boss.pool-rilanci.desc': {
    en: 'Only 2 free rerolls for the WHOLE round.',
    it: 'Solo 2 rilanci liberi per TUTTO il round.',
  },
  'boss.minimo-tris.name': { en: 'No Small Fry', it: 'Niente Bazzecole' },
  'boss.minimo-tris.desc': {
    en: 'Pairs and two pairs don’t count.',
    it: 'Coppie e doppie coppie non contano.',
  },
  'boss.tremante.name': { en: 'Trembling Hand', it: 'Mano Tremante' },
  'boss.tremante.desc': {
    en: 'Every hand starts with TILT +35.',
    it: 'Ogni mano parte con TILT +35.',
  },
  'glass.broken': { en: 'The Glass Die shattered!', it: 'Il Dado di Vetro è andato in frantumi!' },
  'guide.char.h': { en: 'The characters', it: 'I personaggi' },
  'guide.char.p': {
    en: 'Pick who sits at the table: each one starts the run with a different rule.',
    it: 'Scegli chi siede al tavolo: ognuno inizia la run con una regola diversa.',
  },
  'guide.boss.h': { en: 'Boss rounds', it: 'I boss round' },
  'guide.boss.p': {
    en: 'Every third round (3, 6, 9, 12) a BOSS twists one rule for the whole round. The order changes with every run.',
    it: 'Ogni terzo round (3, 6, 9, 12) un BOSS distorce una regola per tutto il round. L’ordine cambia a ogni run.',
  },
  // ── Talismani (nomi ironici, tono sfacciato) ──
  'tal.fix-tre.name': { en: '3 Is the New 6', it: 'Il 3 è il Nuovo 6' },
  'tal.fix-tre.desc': { en: 'Used 3s are worth 6 pips.', it: 'I 3 usati valgono 6 pips.' },
  'tal.fix-pari.name': { en: 'Cult of Even', it: 'Culto del Pari' },
  'tal.fix-pari.desc': { en: '+4 Chips per used even die.', it: '+4 Chips per ogni dado pari usato.' },
  'tal.fix-mono.name': { en: 'Monomania', it: 'Monomania' },
  'tal.fix-mono.desc': { en: 'Single-face combo: +2 Mult.', it: 'Combo di una sola faccia: +2 Molt.' },
  'tal.pyro-sei.name': { en: 'Six Appeal', it: 'Sei Bombastico' },
  'tal.pyro-sei.desc': { en: '+8 Chips per used 6.', it: '+8 Chips per ogni 6 usato.' },
  'tal.pyro-miccia.name': { en: 'Short Fuse', it: 'Miccia Corta' },
  'tal.pyro-miccia.desc': { en: 'Bank with zero rerolls: +2 Mult.', it: 'Incassa senza rilanci: +2 Molt.' },
  'tal.pyro-finale.name': { en: 'Grand Finale', it: 'Gran Finale' },
  'tal.pyro-finale.desc': { en: 'Combo base 120+: Mult ×2.', it: 'Combo con base 120+: Molt. ×2.' },
  'tal.ghost-dado.name': { en: 'Ghost Die', it: 'Dado Fantasma' },
  'tal.ghost-dado.desc': { en: 'Pair-based combo: +15 Chips.', it: 'Combo con coppia: +15 Chips.' },
  'tal.ghost-eco.name': { en: 'Echo', it: 'Eco' },
  'tal.ghost-eco.desc': { en: 'Highest used die counts twice.', it: 'Il dado usato più alto conta due volte.' },
  'tal.ghost-presenza.name': { en: 'The Presence', it: 'La Presenza' },
  'tal.ghost-presenza.desc': { en: '+0.5 Mult per talisman you own.', it: '+0.5 Molt. per talismano che possiedi.' },
  'tal.alch-metallo.name': { en: 'Base Metal', it: 'Vil Metallo' },
  'tal.alch-metallo.desc': { en: 'Used 1s are worth 7 pips.', it: 'Gli 1 usati valgono 7 pips.' },
  'tal.alch-distillato.name': { en: 'The Distillate', it: 'Distillato' },
  'tal.alch-distillato.desc': { en: 'Combo using all 6 dice: +1.5 Mult.', it: 'Combo con tutti e 6 i dadi: +1.5 Molt.' },
  'tal.alch-pietra.name': { en: 'Philosopher’s Stone', it: 'Pietra Filosofale' },
  'tal.alch-pietra.desc': { en: 'Chips +25%.', it: 'Chips +25%.' },
  'tal.risk-freno.name': { en: 'No Brakes', it: 'Freno Rotto' },
  'tal.risk-freno.desc': { en: '+1 Mult per forced reroll this hand.', it: '+1 Molt. per rilancio forzato nella mano.' },
  'tal.risk-limite.name': { en: 'Living on Tilt', it: 'Vivere al Limite' },
  'tal.risk-limite.desc': { en: 'Bank at TILT 50+: +2 Mult.', it: 'Incassa con TILT 50+: +2 Molt.' },
  'tal.risk-berserk.name': { en: 'Berserk', it: 'Berserk' },
  'tal.risk-berserk.desc': {
    en: 'At full TILT chaos sides with you, +2 Mult.',
    it: 'A TILT pieno il caos tifa per te, +2 Molt.',
  },
  'tal.fix-cinque.name': { en: 'Fifth Essence', it: 'Quinta Essenza' },
  'tal.fix-cinque.desc': { en: '+5 Chips per used 5.', it: '+5 Chips per ogni 5 usato.' },
  'tal.fix-dispari.name': { en: 'Odd Lobby', it: 'Lobby del Dispari' },
  'tal.fix-dispari.desc': { en: '+3 Chips per used odd die.', it: '+3 Chips per ogni dado dispari usato.' },
  'tal.fix-scala.name': { en: 'Sequential Fetish', it: 'Feticismo Ordinale' },
  'tal.fix-scala.desc': { en: 'Straights: +2 Mult.', it: 'Le scale: +2 Molt.' },
  'tal.fix-doppietta.name': { en: 'Seeing Double', it: 'Vedo Doppio' },
  'tal.fix-doppietta.desc': { en: 'Two pair: +25 Chips.', it: 'Doppia coppia: +25 Chips.' },
  'tal.fix-tabellina.name': { en: 'Times Two Table', it: 'La Tabellina del 2' },
  'tal.fix-tabellina.desc': {
    en: 'Combo made only of even dice: Mult ×1.5.',
    it: 'Combo di soli dadi pari: Molt. ×1.5.',
  },
  'tal.pyro-polvere.name': { en: 'Powder Keg', it: 'Polveriera' },
  'tal.pyro-polvere.desc': {
    en: 'Hand with at least one forced roll: +20 Chips.',
    it: 'Mano con almeno un tiro forzato: +20 Chips.',
  },
  'tal.pyro-lampo.name': { en: 'Flash in the Pan', it: 'Colpo di Lampo' },
  'tal.pyro-lampo.desc': { en: 'First hand of the round: +15 Chips.', it: 'Prima mano del round: +15 Chips.' },
  'tal.pyro-catena.name': { en: 'Chain Reaction', it: 'Reazione a Catena' },
  'tal.pyro-catena.desc': { en: '+0.5 Mult per reroll used this hand.', it: '+0.5 Molt. per ogni rilancio usato nella mano.' },
  'tal.pyro-castello.name': { en: 'Fireworks Castle', it: 'Castello di Fuochi' },
  'tal.pyro-castello.desc': { en: 'Full house: +2 Mult.', it: 'Full: +2 Molt.' },
  'tal.pyro-apoteosi.name': { en: 'Apotheosis', it: 'Apoteosi' },
  'tal.pyro-apoteosi.desc': { en: 'Quints or Sestetto: Mult ×3.', it: 'Quintetto o Sestetto: Molt. ×3.' },
  'tal.ghost-nebbia.name': { en: 'Thin Mist', it: 'Nebbiolina' },
  'tal.ghost-nebbia.desc': {
    en: 'Combo that leaves dice out: +10 Chips.',
    it: 'Combo che lascia fuori dei dadi: +10 Chips.',
  },
  'tal.ghost-sussurro.name': { en: 'The Whisper', it: 'Sussurro' },
  'tal.ghost-sussurro.desc': {
    en: 'Unused dice whisper: +half their pips as Chips.',
    it: 'I dadi non usati sussurrano: +metà dei loro pips ai Chips.',
  },
  'tal.ghost-terzo.name': { en: 'Third Wheel', it: 'Il Terzo Incomodo' },
  'tal.ghost-terzo.desc': { en: 'Trips: +30 Chips.', it: 'Tris: +30 Chips.' },
  'tal.ghost-specchi.name': { en: 'Hall of Mirrors', it: 'Sala degli Specchi' },
  'tal.ghost-specchi.desc': {
    en: '+4 Chips per pair on the table, even outside the combo.',
    it: '+4 Chips per ogni coppia sul tavolo, anche fuori combo.',
  },
  'tal.ghost-medium.name': { en: 'The Medium', it: 'Il Medium' },
  'tal.ghost-medium.desc': { en: '+1 Mult per unused die.', it: '+1 Molt. per ogni dado NON usato.' },
  'tal.alch-mercurio.name': { en: 'Quicksilver', it: 'Mercurio' },
  'tal.alch-mercurio.desc': { en: '+1 Chip per used die.', it: '+1 Chip per ogni dado usato.' },
  'tal.alch-fermento.name': { en: 'Ferment', it: 'Fermento' },
  'tal.alch-fermento.desc': { en: '+2 Chips per completed round.', it: '+2 Chips per ogni round completato.' },
  'tal.alch-piombo-oro.name': { en: 'Lead to Gold', it: 'Piombo in Oro' },
  'tal.alch-piombo-oro.desc': { en: '+6 Chips per used special die.', it: '+6 Chips per ogni dado speciale usato.' },
  'tal.alch-enzima.name': { en: 'The Enzyme', it: 'Enzima' },
  'tal.alch-enzima.desc': { en: 'Combo of exactly 4 dice: +1.5 Mult.', it: 'Combo di esattamente 4 dadi: +1.5 Molt.' },
  'tal.alch-grande-opera.name': { en: 'Magnum Opus', it: 'La Grande Opera' },
  'tal.alch-grande-opera.desc': {
    en: '+0.75 Mult per different family you own.',
    it: '+0.75 Molt. per ogni famiglia diversa che possiedi.',
  },
  'tal.risk-adrenalina.name': { en: 'Adrenaline', it: 'Adrenalina' },
  'tal.risk-adrenalina.desc': { en: 'Bank at TILT 35+: +12 Chips.', it: 'Incassa con TILT 35+: +12 Chips.' },
  'tal.risk-cerino.name': { en: 'Last Match', it: 'L’Ultimo Cerino' },
  'tal.risk-cerino.desc': { en: 'Last hand of the round: +20 Chips.', it: 'Ultima mano del round: +20 Chips.' },
  'tal.risk-vertigine.name': { en: 'Vertigo', it: 'Vertigine' },
  'tal.risk-vertigine.desc': { en: '+1 Mult per 25 TILT.', it: '+1 Molt. ogni 25 di TILT.' },
  'tal.risk-fenice.name': { en: 'Phoenix', it: 'Fenice' },
  'tal.risk-fenice.desc': { en: 'Hand hit by full-TILT chaos: +40 Chips.', it: 'Mano travolta dal caos: +40 Chips.' },
  'tal.risk-abisso.name': { en: 'The Abyss Stares', it: 'L’Abisso Guarda' },
  'tal.risk-abisso.desc': { en: 'Bank at TILT 70+: Mult ×2.', it: 'Incassa con TILT 70+: Molt. ×2.' },
  // ── Dadi speciali ──
  'die.pari.name': { en: 'Even Die', it: 'Dado Pari' },
  'die.pari.desc': { en: 'Rolls only 2, 4 and 6.', it: 'Tira solo 2, 4 e 6.' },
  'die.bomba.name': { en: 'Bomb Die', it: 'Dado Bomba' },
  'die.bomba.desc': { en: '+10 Chips when its 6 lands in a combo.', it: '+10 Chips quando il suo 6 finisce in combo.' },
  'die.specchio.name': { en: 'Mirror Die', it: 'Dado Specchio' },
  'die.specchio.desc': { en: 'Copies its left-hand neighbor.', it: 'Copia il vicino di sinistra.' },
  'die.piombato.name': { en: 'Loaded Die', it: 'Dado Piombato' },
  'die.piombato.desc': { en: '60% chance to repeat its last face.', it: '60% di ripetere l’ultima faccia.' },
  'die.d8.name': { en: 'The D8', it: 'Dado D8' },
  'die.d8.desc': { en: 'Faces from 1 to 8: fatter pips, longer straights.', it: 'Facce da 1 a 8: pips più grassi, scale più lunghe.' },
  'die.vetro.name': { en: 'Glass Die', it: 'Dado di Vetro' },
  'die.vetro.desc': { en: 'Double pips, but shatters after 3 combos.', it: 'Pips doppi, ma si rompe dopo 3 combo.' },
  'die.magnete.name': { en: 'Magnet Die', it: 'Dado Magnete' },
  'die.magnete.desc': { en: 'Snaps to the most common face on the table.', it: 'Si aggancia alla faccia più comune del tavolo.' },
  'die.brace.name': { en: 'Ember Die', it: 'Dado di Brace' },
  'die.brace.desc': { en: '+2 Chips whenever it lands in a combo.', it: '+2 Chips ogni volta che finisce in combo.' },
  'die.truccato.name': { en: 'Shaved Die', it: 'Dado Truccato' },
  'die.truccato.desc': { en: 'Never rolls a 1.', it: 'Non tira mai 1.' },
  'die.caos.name': { en: 'Chaos Die', it: 'Dado del Caos' },
  'die.caos.desc': { en: 'Always rolls twice and keeps the best.', it: 'Tira sempre due volte e tiene il meglio.' },
} satisfies Record<string, Record<Lang, string>>;

export type I18nKey = keyof typeof dict;

let current: Lang = (() => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'en' || saved === 'it') return saved;
  } catch { /* storage bloccato (iframe portali): default EN */ }
  return 'en';
})();

export function getLang(): Lang {
  return current;
}

export function setLang(lang: Lang): void {
  current = lang;
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch { /* best effort */ }
}

export function t(key: I18nKey, vars?: Record<string, string | number>): string {
  let out: string = dict[key][current];
  if (vars) for (const [k, v] of Object.entries(vars)) out = out.replace(`{${k}}`, String(v));
  return out;
}
